/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoMalattiaUpdateDTO
 */
export interface AssistitoMalattiaUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoMalattiaUpdateDTO
     */
    tipo?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoMalattiaUpdateDTO
     */
    sintomi?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoMalattiaUpdateDTO
     */
    terapia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoMalattiaUpdateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoMalattiaUpdateDTO interface.
 */
export function instanceOfAssistitoMalattiaUpdateDTO(value: object): value is AssistitoMalattiaUpdateDTO {
    return true;
}

export function AssistitoMalattiaUpdateDTOFromJSON(json: any): AssistitoMalattiaUpdateDTO {
    return AssistitoMalattiaUpdateDTOFromJSONTyped(json, false);
}

export function AssistitoMalattiaUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoMalattiaUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'tipo': json['tipo'] == null ? undefined : json['tipo'],
        'sintomi': json['sintomi'] == null ? undefined : json['sintomi'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoMalattiaUpdateDTOToJSON(value?: AssistitoMalattiaUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tipo': value['tipo'],
        'sintomi': value['sintomi'],
        'terapia': value['terapia'],
        'note': value['note'],
    };
}

